var letterFactor = 6;
var fixedSpace = 48;
function calculateWidth(options) {
  var longest = options.reduce(function (a, b) {
    if (a && a.label && b && b.label) return a.label.length > b.label.length ? a : b;
    return 0;
  });

  if (longest && longest.label && longest.label.length) {
    return longest.label.length * letterFactor + fixedSpace;
  }

  return 0;
}

export { calculateWidth };
//# sourceMappingURL=calculateWidth.js.map
